<template>
  <v-dialog v-model="dialog" width="700" persistent>
    <v-card>
      <v-card-title>
        <span class="headline">Vendor Account Number</span>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12" sm="12" md="12" lg="12">
            <v-row>
              <v-col cols="4" sm="4" md="4" lg="4" class="py-0">
                <v-subheader>Existing Account Number</v-subheader>
              </v-col>
              <v-col cols="8" sm="8" md="8" lg="8">
                <v-select
                  dense
                  outlined
                  flat
                  background-color="white"
                  v-model="form"
                  return-object
                  item-text="accountNumber"
                  :items="listAccountNumber"
                  @change="onChangeAccountNumber"
                >
                  <template v-slot:item="data">
                    <v-list-item v-on="data.on">
                      <v-list-item-content>
                        <v-list-item-title v-html="data.item.accountNumber"></v-list-item-title>
                        <v-list-item-subtitle v-html="data.item.ownerName"></v-list-item-subtitle>
                        <v-list-item-subtitle
                          v-html="data.item.bankExternal.name"
                        ></v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                  <template v-slot:append-outer v-if="form.id">
                    <v-btn color="success" @click="addAccountNumber"
                      ><v-icon>mdi-plus</v-icon></v-btn
                    >
                  </template>
                </v-select>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="12" md="12" lg="12">
            <v-row>
              <v-col cols="4" sm="4" md="4" lg="4" class="py-0">
                <v-subheader>Bank</v-subheader>
              </v-col>
              <v-col cols="8" sm="8" md="8" lg="8">
                <v-autocomplete
                  outlined
                  flat
                  dense
                  background-color="white"
                  append-icon="mdi-magnify"
                  :items="banks"
                  item-text="name"
                  return-object
                  v-model="form.bankExternal"
                  :disabled="form.id && form.id > 0"
                >
                </v-autocomplete>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="12" md="12" lg="12">
            <v-row>
              <v-col cols="4" sm="4" md="4" lg="4" class="py-0">
                <v-subheader>Account Number</v-subheader>
              </v-col>
              <v-col cols="8" sm="8" md="8" lg="8" class="py-0">
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      outlined
                      flat
                      dense
                      background-color="white"
                      v-model="form.accountNumber"
                      :disabled="form.id && form.id > 0"
                    ></v-text-field
                  ></v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="12" md="12" lg="12">
            <v-row>
              <v-col cols="4" sm="4" md="4" lg="4" class="py-0">
                <v-subheader>Owner Name</v-subheader>
              </v-col>
              <v-col cols="8" sm="8" md="8" lg="8" class="py-0">
                <v-text-field
                  outlined
                  flat
                  dense
                  background-color="white"
                  v-model="form.ownerName"
                  :disabled="form.id && form.id > 0"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="12" lg="12">
            <v-row>
              <v-col cols="4" sm="4" md="4" lg="4" class="py-0">
                <v-subheader>BI Fast</v-subheader>
              </v-col>
              <v-col cols="8" sm="8" md="8" lg="8" class="py-0">
                <v-checkbox
                  outlined
                  flat
                  dense
                  background-color="white"
                  v-model="form.different"
                  :disabled="form.id && form.id > 0"
                ></v-checkbox>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="close">
          Close
        </v-btn>
        <v-btn color="primary" @click="save">
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "dialog-kasbon",
  props: {
    dialog: Boolean,
    form: Object,
    banks: Array,
    listAccountNumber: Array,
    id: Number,
  },
  methods: {
    addAccountNumber() {
      const body = {
        id: null,
        accountNumber: "",
        bankExternal: null,
        ownerName: "",
        different: true,
        vendorId: this.form.vendorId,
        type: 0,
      };
      this.$emit("update", body);
    },
    onChangeAccountNumber(value) {
      this.$emit("update", value);
    },
    save() {
      this.$emit("save", { body: this.form, id: this.id });
    },
    close() {
      this.$emit("close");
    },
  },
};
</script>

<style></style>
